"use client";

import type React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { SWRConfig } from "swr";
import LoadingScreen from "@/app/components/LoadingScreen";
import VersionPoller from "@/app/components/VersionPoller";
import { persistor, store } from "./store";

interface ReduxProviderProps {
	children: React.ReactNode;
}

export const ReduxProvider: React.FC<ReduxProviderProps> = ({ children }) => {
	return (
		<Provider store={store}>
			<PersistGate loading={<LoadingScreen />} persistor={persistor}>
				<SWRConfig
					value={{
						revalidateOnFocus: false,
						revalidateOnReconnect: false,
						revalidateIfStale: true,
						keepPreviousData: true,
						dedupingInterval: 5 * 60 * 1000, // 5 minutes
						focusThrottleInterval: 5000,
						errorRetryCount: 2,
						errorRetryInterval: 5000,
						shouldRetryOnError: (error: any) => {
							return error?.status >= 500;
						},
					}}
				>
					{children}
					<VersionPoller />
				</SWRConfig>
			</PersistGate>
		</Provider>
	);
};
